import { NextImage, RichText } from '@sitecore-jss/sitecore-jss-nextjs';
import { StContentBox, StImageContentCardBox } from './ImageContentCard.style';
import { tilesListProps } from './ImageContentCard.type';
import { StNextImage } from '../../shared/NextImage.styles';
import UiHeading from '../Heading';
import UiText from '../Typography/UiText';

const ImageContentCard = (props: tilesListProps): JSX.Element => {
  if (!props) return <></>;
  const { icon, title, description } = props?.fields;
  const { onClickHandler = () => void 0, onKeyUp = () => void 0 } = props;
  const overrideIconColor = props?.overrideIconColor || '';
  return (
    <StImageContentCardBox
      bgcolor="white"
      data-testid="image-content-card"
      id="image-content-card"
      className="ui-image-content-card"
      onClick={() => onClickHandler(props?.fields)}
      onKeyUp={(e: any) => {
        onKeyUp(e, props?.fields);
      }}
    >
      <div style={{ minWidth: '76px', minHeight: '75px' }}>
        {overrideIconColor ? (
          <StNextImage
            field={icon}
            data-testid="image-content-image"
            width={76}
            height={75}
            overrideIconColor={overrideIconColor}
          />
        ) : (
          <NextImage field={icon} data-testid="image-content-image" width={76} height={75} />
        )}
      </div>
      <StContentBox>
        <UiHeading data-testid="image-content-title" size="h4">
          {title}
        </UiHeading>
        <UiText data-testid="image-content-description">
          <RichText field={description} />
        </UiText>
      </StContentBox>
    </StImageContentCardBox>
  );
};

export default ImageContentCard;
